/**
 *
 * Asynchronously loads the component for UserList
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
